import { render } from "./LifeInsurance.vue?vue&type=template&id=1bf36e70"
import script from "./LifeInsurance.vue?vue&type=script&lang=js"
export * from "./LifeInsurance.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__